import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { handleAxiosError } from "../../config/action-config";

import {
  Typography,
  Grid,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  TextField,
} from "@mui/material";
import { getEmployees } from "../../api/employee";

export default function ProjectTaskAddEmployeeDialog({
  open,
  setOpen,
  onAdd,
  employees,
  lowestTasks,
  projectType,
}) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState({
    employee_id: "",
    project_role: "TM",
    task_id: "",
    bill_rate: "",
  });
  const [freeEmployees, setFreeEmployees] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) return;
    getEmployees({}, user.token)
      .then((res) => {
        const all = res.data.data;
        // const assignedIds = employees.map((e) => e.id);
        // setFreeEmployees(all.filter((e) => !assignedIds.includes(e.id)));
        setFreeEmployees(all);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen("ADD_EMPLOYEE");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // const errors = validate(data);
          // if (Object.keys(errors).length === 0) {
          onAdd(data);

          // }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Add Resource to Project
        </DialogTitle>
        <DialogContent>
          <Grid container minWidth={500} spacing={2} sx={{ pt: 2 }}>
            {lowestTasks.length ? (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Resource
                    </InputLabel>
                    <Select
                      required
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={data.employee_id}
                      label="Resource"
                      name="employee_id"
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                    >
                      {freeEmployees.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.email}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label-task">
                      Task
                    </InputLabel>
                    <Select
                      required
                      labelId="demo-simple-select-label-task"
                      id="demo-simple-select-task"
                      value={data.task_id}
                      label="Task"
                      name="task_id"
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                    >
                      {lowestTasks.map((t, i) => (
                        <MenuItem key={i} value={t.id}>
                          {t.task_code} - {t.task_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {projectType === "FIXED" || projectType === "SUBSCRIPTION" ? (
                  <></>
                ) : (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      margin="dense"
                      name="bill_rate"
                      fullWidth
                      value={data.bill_rate}
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                      label="Bill Rate($)"
                      type="number"
                      variant="outlined"
                    />
                  </Grid>
                )}
              </>
            ) : (
              <Grid item xs={12} md={12}>
                <Typography
                  color="red"
                  sx={{ border: "1px solid red", borderRadius: "5px", p: 1 }}
                >
                  Please create tasks for the project first.
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen("PROJECT_TASK_ADD_EMPLOYEE");
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            // onClick={() => {
            //   onAdd(data);
            // }}
            className="blue-button"
          >
            Add
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
